import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaCard } from "./VaCard-c5095838.mjs";
import { V as VaCardContentBase } from "./components/va-card-content/VaCardContent-dd835113.mjs";
import { V as VaCardTitleBase } from "./components/va-card-title/VaCardTitle-102648f6.mjs";
import { V as VaCardActionsBase } from "./components/va-card-actions/VaCardActions-afc2d9a8.mjs";
import { V as VaCardBlockBase } from "./components/va-card-block/VaCardBlock-1bd093f1.mjs";
const VaCardContent = withConfigTransport(VaCardContentBase);
const VaCardTitle = withConfigTransport(VaCardTitleBase);
const VaCardActions = withConfigTransport(VaCardActionsBase);
const VaCardBlock = withConfigTransport(VaCardBlockBase);
const VaCard = withConfigTransport(_VaCard);
export {
  VaCardContent as V,
  VaCardTitle as a,
  VaCardActions as b,
  VaCardBlock as c,
  VaCard as d
};
//# sourceMappingURL=index-8f0cf1cc.mjs.map
